function init(_, el) {
  const video = $(el).find('.video');
  const iframe = $(el).find('iframe');

  video.on('click', function () {
    $(el).find('.video-img').addClass('hide');
    $(el).find('.play-stop-btn').addClass('hide');
    iframe.attr('src', iframe.data('src'));
  });
}

export default function () {
  $('section[data-block="video"]').each(init);
}
